import { useContext, useMemo } from 'react';
import I18n from 'I18n';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import UISelect from 'UIComponents/input/UISelect';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { useOnChangeHandlers } from '../../hooks/useOnChangeHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterGroupLogicGroupToggle = ({
  logicGroupIndex
}) => {
  const {
    internalDraftValue,
    dispatch
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    handleOnChange
  } = useOnChangeHandlers();
  const options = useMemo(() => [{
    value: LogicGroupNames.OR,
    text: I18n.text(`newCustomerDataFilters.filterGroupLogicGroupSelection.Or`)
  }, {
    value: LogicGroupNames.AND,
    text: I18n.text(`newCustomerDataFilters.filterGroupLogicGroupSelection.And`)
  }], []);
  const getLogicGroup = () => {
    var _internalDraftValue$c;
    return internalDraftValue === null || internalDraftValue === void 0 || (_internalDraftValue$c = internalDraftValue.conditions.get(String(logicGroupIndex))) === null || _internalDraftValue$c === void 0 ? void 0 : _internalDraftValue$c.logicGroupName;
  };
  const handleLogicGroupChange = e => {
    const newLogicGroupName = e.target.value;
    if (internalDraftValue) {
      const newInternalDraftValue = internalDraftValue.setIn(['conditions', String(logicGroupIndex)], internalDraftValue.conditions.get(String(logicGroupIndex)).set('logicGroupName', newLogicGroupName));
      dispatch({
        type: 'internalDraftValue',
        payload: newInternalDraftValue
      });
      handleOnChange(newInternalDraftValue);
    }
  };
  return /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": "fr-filter-group-logic-group-toggle",
    value: getLogicGroup(),
    onChange: handleLogicGroupChange,
    options: options
  });
};
export default FilterGroupLogicGroupToggle;